import { defaultKeybindings } from '../model/defaultKeybindings';
import type { KeybindingCommandId, KeybindingScope } from '../model/keybindingTypes';

/** Section order of the Settings tab: the editors users rebind most come first. */
export const SCOPE_ORDER: readonly KeybindingScope[] = [
  'query-editor',
  'sql-editor',
  'notebook',
  'vqe',
  'plsql-editor',
  'debugger',
  'breadcrumb',
  'global',
];

export const SCOPE_TITLES: Readonly<Record<KeybindingScope, string>> = {
  'query-editor': 'Query Editor',
  'sql-editor': 'Any SQL editor',
  notebook: 'Notebooks',
  vqe: 'Visual Query Editor',
  'plsql-editor': 'PL/SQL editor',
  debugger: 'PL/SQL debugger',
  breadcrumb: 'Foreign key breadcrumb',
  global: 'Global',
};

/** "…takes it in <context>" — the place where a scoped command's binding is live. */
export const SCOPE_CONTEXT: Readonly<Record<KeybindingScope, string>> = {
  'query-editor': 'a Query Editor tab',
  'sql-editor': 'a SQL editor',
  notebook: 'a notebook',
  vqe: 'the Visual Query Editor',
  'plsql-editor': 'the PL/SQL editor',
  debugger: 'the debugger',
  breadcrumb: 'the Table Explorer breadcrumb',
  global: 'every part of the app',
};

export type KeybindingGroup = {
  readonly scope: KeybindingScope;
  readonly commandIds: readonly KeybindingCommandId[];
};

export function groupCommandsByScope(commandIds: readonly KeybindingCommandId[]): KeybindingGroup[] {
  return SCOPE_ORDER.flatMap((scope) => {
    const inScope = commandIds.filter((id) => defaultKeybindings[id].scope === scope);
    return inScope.length > 0 ? [{ scope, commandIds: inScope }] : [];
  });
}
